module.exports = __webpack_public_path__ + "static/media/customer.b8266c67.svg";